import { useTranslation } from "react-i18next";
import { BadgeCheck } from "lucide-react";

// Badge unico "Profilo verificato da YouPAM": compare SOLO se verified === true.
// Icona check riconoscibile (non solo colore), tooltip + aria-label localizzati.
export function VerifiedBadge({ size = 16, className = "" }) {
  const { t } = useTranslation();
  const label = t("auth.badge_verified");
  return (
    <span title={label} aria-label={label} role="img" data-testid="verified-badge"
      className={`inline-flex items-center align-middle shrink-0 ${className}`}>
      <BadgeCheck size={size} className="fill-blue-600 text-white" strokeWidth={2} />
    </span>);
}
